const theme = {
  fonts: {
    primary: 'Mark',
    secondary: 'Noto',
    tertiary: 'Mark-slim',
    quaternary: 'Noto-slim'
  },
  palette: {
    primary: ['#2E3191', '#FF0000'],
    secondary: ['#EFC569', '#EFE2C8', '#CDA243', '#B3884F', '#EFE2C8'],
    grayscale: ['#000000', '#404040', '#808080', '#A9A9A9', '#D3D3D3', '#F5F5F5', '#FFFFFF'],
    white: ['#FFFFFF'],
  },
  sizes: {
    maxWidth: '1280px',
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
};

export default theme;
